import React, { useEffect, useState } from "react";
import "./Steps.scss";
import { Steps, Button, Form, Input, Select, Modal } from "antd";
import imageFormModal from "../../../assets/images/png/image-form.png";
import VideoConsultation from "./stepsForm/VideoConsultation";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import { APIV3 } from "../../../utils/customAxios";
import { useHistory } from "react-router-dom";
import Loader from "../../../uiComponents/loader/Loader";
import Cookies from "js-cookie";
import { isMobile } from "react-device-detect";
import { TermsModal } from "../../modal/termsAndConditionModal/TermsAndConditionModal";
const { Step } = Steps;
const { Option } = Select;

const StepThree = ({
  setQualification,
  setConsultation,
  setListner,
  profileVerification,
  setProfileVerification,
  moveToProfileVerification,
}) => {
  const history = useHistory();

  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [confirmFormSubmit, setConfirmFormSubmit] = useState(false);
  const [submitForm, setSubmitForm] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [videoConsultCheckbox, setVideoConsultCheckbox] = useState(false);
  const [videoClinicCheckbox, setVideoClinicCheckbox] = useState(false);
  const [submissionLoader, setSubmissionLoader] = useState(false);
  const [termsModalShow, setTermsModalShow] = useState(false);

  const [videoClinics, setVideoClinics] = useState([
    {
      id: 1,
    },
  ]);

  const [videoSlots, setVideoSlots] = useState([
    {
      clinicId: 1,
      slotsId: 1,
    },
  ]);

  // const [videoTimeSlots, setVideoTimeSlots] = useState([
  //   {
  //     clinicId: 1,
  //     slotsId: 1,
  //     timeSlotId: 1,
  //     day: "",
  //   },
  // ]);
  const [videoTimeSlots, setVideoTimeSlots] = useState([]);

  const [clinicVisit, setClinicVisit] = useState([
    {
      id: 1,
    },
  ]);

  const [clinicSlots, setClinicSlots] = useState([
    {
      clinicId: 1,
      slotsId: 1,
    },
  ]);

  const [clinicTimeSlots, setClinicTimeSlots] = useState([
    {
      clinicId: 1,
      slotsId: 1,
      timeSlotId: 1,
      day: "",
    },
  ]);

  useEffect(() => {
    APIV3.get(`/doctor/profile-details?clinics=1`).then((res) => {
      if (res?.status == 200) {
        setProfileData(res?.data?.data);
      }
    });
  }, []);

  // Prefilled Video Data
  useEffect(() => {
    if (Object.keys(profileData)?.length > 0) {
      const doctorClinics = profileData?.doctor_clinics;

      if (doctorClinics?.length > 0) {
        let tempVideoSlots = [];
        let timeSlotsArr = [];
        let dayMap = {}; // { slotsId: day }

        for (let i = 0; i < doctorClinics.length; i++) {
          const clinic = doctorClinics[i];

          if (clinic?.clinic_id === 0) {
            form.setFieldsValue({
              video_mins: clinic.consultation_duration,
              video_fee: clinic.consultation_fee,
            });

            const clinicTimings = clinic.clinic_timings || [];

            clinicTimings.forEach((timing, index) => {
              const currentSlotId = timing.slots_id;

              // Set time fields
              form.setFieldsValue({
                [`video_starttime${index + 1}`]: moment(
                  timing.start_hour,
                  "HH:mm:ss"
                ),
                [`video_starttimemin${index + 1}`]: moment()
                  .minute(Number(timing.start_minute))
                  .second(0),

                [`video_endtime${index + 1}`]: moment(
                  timing.end_hour,
                  "HH:mm:ss"
                ),
                [`video_endtimemin${index + 1}`]: moment()
                  .minute(Number(timing.end_minute))
                  .second(0),
              });

              // Save the single selected day (radio)
              if (!dayMap[currentSlotId]) {
                dayMap[currentSlotId] = timing.day;
              }

              // Create timeSlot entry
              timeSlotsArr.push({
                clinicId: 1,
                slotsId: currentSlotId,
                timeSlotId: index + 1,
                day: timing.day || "",
              });

              // Create unique slot entry if not already added
              if (!tempVideoSlots.find((vs) => vs.slotsId === currentSlotId)) {
                tempVideoSlots.push({
                  clinicId: 1,
                  slotsId: currentSlotId,
                });
              }
            });

            // Set selected day for each slot (radio value)
            Object.entries(dayMap).forEach(([slotId, day]) => {
              form.setFieldsValue({
                [`video_day${slotId}`]: day, // now a single string value
              });
            });

            // Final state updates
            setVideoSlots(tempVideoSlots);
            setVideoTimeSlots(timeSlotsArr);
          }
        }
      }
    }
  }, [JSON.stringify(profileData)]);

  useEffect(() => {
    if (Object.keys(profileData)?.length > 0) {
      let doctorClinics = profileData?.doctor_clinics;
      doctorClinics = doctorClinics?.filter((clinic) => {
        return clinic?.clinic_id != 0;
      });

      if (doctorClinics?.length > 0) {
        let tempVideoSlots = [];
        let timeSlotsArr = [];
        let dayMap = {}; // { slotsId: day }

        for (let i = 0; i < doctorClinics.length; i++) {
          const clinic = doctorClinics[i];

          if (clinic?.clinic_id !== 0) {
            // form.setFieldsValue({
            //   [`visit-clinic_id${i + 1}`]: doctorClinics?.[i]?.clinic_id,
            //   [`visit-consultation_fee${i + 1}`]:
            //     doctorClinics?.[i]?.consultation_fee,
            //   [`visit-mins${i + 1}`]: doctorClinics?.[i]?.consultation_duration,
            // });

            form.setFieldsValue({
              visit_clinic_id: clinic?.clinic_id,
              visit_clinic_location: clinic?.consultation_location,
              clinic_visit_mins: clinic?.consultation_duration,
              visit_consultation_fee: clinic?.consultation_fee,
            });

            const clinicTimings = clinic.clinic_timings || [];

            clinicTimings.forEach((timing, index) => {
              const currentSlotId = timing.slots_id;

              // Set time fields
              form.setFieldsValue({
                [`visit_start_time${index + 1}`]: moment(
                  timing.start_hour,
                  "HH:mm:ss"
                ),
                [`visit_start_timeMin${index + 1}`]: moment("00:00", "HH:mm")
                  .minute(Number(timing.start_minute))
                  .second(0),

                [`visit_end_time${index + 1}`]: moment(
                  timing.end_hour,
                  "HH:mm:ss"
                ),
                [`visit_end_timemin${index + 1}`]: moment("00:00", "HH:mm")
                  .minute(Number(timing.end_minute))
                  .second(0),
              });

              // Save the single selected day (radio)
              if (!dayMap[currentSlotId]) {
                dayMap[currentSlotId] = timing.day;
              }

              // Create timeSlot entry
              timeSlotsArr.push({
                clinicId: 1,
                slotsId: currentSlotId,
                timeSlotId: index + 1,
                day: timing.day || "",
              });

              // Create unique slot entry if not already added
              if (!tempVideoSlots.find((vs) => vs.slotsId === currentSlotId)) {
                tempVideoSlots.push({
                  clinicId: 1,
                  slotsId: currentSlotId,
                });
              }
            });

            // Set selected day for each slot (radio value)
            Object.entries(dayMap).forEach(([slotId, day]) => {
              form.setFieldsValue({
                [`visit-day${slotId}`]: day, // now a single string value
              });
            });

            // Final state updates
            setClinicSlots(tempVideoSlots);
            setClinicTimeSlots(timeSlotsArr);
          }
        }
      }
    }
  }, [JSON.stringify(profileData)]);

  const handleNext = async (e, save) => {
    try {
      let fieldsToValidate = [];

      if (videoClinicCheckbox) {
        fieldsToValidate.push("visit-clinic_id1");
        fieldsToValidate.push("visit-mins1");
        fieldsToValidate.push("visit-consultation_fee1");
        fieldsToValidate.push("visit-start_time1");
        clinicTimeSlots.forEach((item) => {
          fieldsToValidate.push(`visit-end_time${item?.timeSlotId}`);
          fieldsToValidate.push(`visit-clinic_location${item.clinicId}`);
        });
      }

      if (videoConsultCheckbox) {
        fieldsToValidate.push("video_mins");
        fieldsToValidate.push("video_fee");
        fieldsToValidate.push("video_starttime1");
        videoTimeSlots.forEach((item) => {
          fieldsToValidate.push(`video_endtime${item?.timeSlotId}`);
        });
      }

      await form.validateFields(fieldsToValidate);

      const values = form.getFieldsValue();

      let videoPayload = {};

      // if (values.hasOwnProperty("video_mins")) {
      //   videoPayload.consultation_duration = values["video_mins"];
      //   videoPayload.consultation_fee = values["video_fee"];

      //   let schedule = [];

      //   for (let i = 0; i < videoSlots.length; i++) {
      //     for (let j = 0; j < videoTimeSlots.length; j++) {
      //       if (videoSlots[i].slotsId === videoTimeSlots[j].slotsId) {
      //         // Get both times
      //         const startHourMoment = moment(values[`video_starttime${j + 1}`]);
      //         const startMinuteMoment = moment(
      //           values[`video_starttimemin${j + 1}`]
      //         );

      //         const endHourMoment = moment(values[`video_endtime${j + 1}`]);
      //         const endMinuteMoment = moment(
      //           values[`video_endtimemin${j + 1}`]
      //         );

      //         // Combine hour and minute
      //         const combinedStartTime = moment()
      //           .hour(startHourMoment.hour())
      //           .minute(startMinuteMoment.minute())
      //           .second(0);

      //         const combinedEndTime = moment()
      //           .hour(endHourMoment.hour())
      //           .minute(endMinuteMoment.minute())
      //           .second(0);
      //         schedule.push({
      //           slotsId: videoTimeSlots[j].slotsId,
      //           days: videoTimeSlots[j].day, // monday is temporary when first time slots add
      //           start_time: combinedStartTime.format("HH:mm:ss"),
      //           end_time: combinedEndTime.format("HH:mm:ss"),
      //         });
      //       }
      //     }
      //   }

      //   videoPayload.schedule = schedule;
      // }

      //Payload setup for clinic visit


      if (values.hasOwnProperty("video_mins")) {
  videoPayload.consultation_duration = values["video_mins"];
  videoPayload.consultation_fee = values["video_fee"];

  let schedule = [];

  for (let i = 0; i < videoSlots.length; i++) {
    for (let j = 0; j < videoTimeSlots.length; j++) {
      if (videoSlots[i].slotsId === videoTimeSlots[j].slotsId) {
        const timeSlotId = videoTimeSlots[j].timeSlotId;

        // Get both times using timeSlotId
        const startHourMoment = moment(values[`video_starttime${timeSlotId}`]);
        const startMinuteMoment = moment(values[`video_starttimemin${timeSlotId}`]);

        const endHourMoment = moment(values[`video_endtime${timeSlotId}`]);
        const endMinuteMoment = moment(values[`video_endtimemin${timeSlotId}`]);

        // Combine hour and minute
        const combinedStartTime = moment()
          .hour(startHourMoment.hour())
          .minute(startMinuteMoment.minute())
          .second(0);

        const combinedEndTime = moment()
          .hour(endHourMoment.hour())
          .minute(endMinuteMoment.minute())
          .second(0);

        schedule.push({
          slotsId: videoTimeSlots[j].slotsId,
          days: videoTimeSlots[j].day,
          start_time: combinedStartTime.format("HH:mm:ss"),
          end_time: combinedEndTime.format("HH:mm:ss"),
        });
      }
    }
  }

  videoPayload.schedule = schedule;
}

      let clinicPayload = {};

      let clinic = [];

      if (values.hasOwnProperty("clinic_visit_mins")) {
        clinicPayload.clinic_id = values["visit_clinic_id"];
        clinicPayload.location = values["visit_clinic_location"];
        clinicPayload.consultation_duration = values["clinic_visit_mins"];
        clinicPayload.consultation_fee = values["visit_consultation_fee"];

      let clinicLocal = [];

for (let i = 0; i < clinicTimeSlots.length; i++) {
  const { timeSlotId, slotsId, day } = clinicTimeSlots[i];

  const startHourMoment = moment(values[`visit_start_time${timeSlotId}`]);
  const startMinuteMoment = moment(values[`visit_start_timeMin${timeSlotId}`]);

  const endHourMoment = moment(values[`visit_end_time${timeSlotId}`]);
  const endMinuteMoment = moment(values[`visit_end_timemin${timeSlotId}`]);

  const combinedStartTime = moment()
    .hour(startHourMoment.hour())
    .minute(startMinuteMoment.minute())
    .second(0);

  const combinedEndTime = moment()
    .hour(endHourMoment.hour())
    .minute(endMinuteMoment.minute())
    .second(0);

  clinicLocal.push({
    slotsId,
    days: day,
    start_time: combinedStartTime.format("HH:mm:ss"),
    end_time: combinedEndTime.format("HH:mm:ss"),
  });
}


        clinicPayload.schedule = clinicLocal;
      }

      clinic.push(clinicPayload);

      let payload = {};

      if (Object.keys(videoPayload).length > 0) {
        payload.is_video_consultation = videoPayload;
      }

      if (Object.keys(clinicPayload).length > 0) {
        payload.is_clinic_visit = clinic;
      }

      try {
        setSubmissionLoader(true);
        const response = await APIV3.post("/doctor/time-slots", payload);
        setSubmissionLoader(false);
        if (response?.status == 200) {
          // Cookies.remove("pageStatus");
          profileSubmittedAPI()
          Cookies.set("pageStatus", "profileVerification");
          setProfileVerification(true);
          setConsultation(false);
          toast.success("Details submitted successfully");
          setListner((prevStep) => !prevStep);
          moveToProfileVerification();
          setConfirmFormSubmit(true);
        } else {
          toast.success(response?.data?.message);
        }
      } catch (error) {
        setSubmissionLoader(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const profileSubmittedAPI = async () => {
    try {
      const response = await APIV3.get("/doctor/profile-submitted");
      if (response?.status == 200) {
        // console.log(response, "response")
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlerConfirmFormSubmit = () => {
    setConfirmFormSubmit(true);
  };

  const handleSubmitForm = () => {
    setConfirmFormSubmit(false);
    setSubmitForm(true);
  };

  // For clinic visit state and manipulation functions
  function addAnotherClinic() {
    addClinicTimeSlot(null, clinicVisit.length + 1, clinicSlots.length + 1);
    addClinicSlot(null, clinicVisit.length + 1);

    setClinicVisit([...clinicVisit, { id: clinicVisit.length + 1 }]);
  }

  function deleteClinic(e, clinicId) {
    setClinicVisit(clinicVisit?.filter((clinic) => clinic?.id != clinicId));
  }

  function addClinicSlot(e, clinicId) {
    addClinicTimeSlot(null, clinicId, clinicSlots.length + 1);
    setClinicSlots([
      ...clinicSlots,
      {
        clinicId: clinicId,
        slotsId: clinicSlots.length + 1,
      },
    ]);
  }

  function deleteClinicSlot(e, slotId) {
    const slots = clinicSlots?.filter((item) => {
      return item?.slotsId !== slotId;
    });

    setClinicSlots(slots);
  }

  function addClinicTimeSlot(e, clinicId, slotId) {
    setClinicTimeSlots([
      ...clinicTimeSlots,
      {
        clinicId: clinicId,
        slotsId: slotId,
        timeSlotId: clinicTimeSlots.length + 1,
      },
    ]);
  }

  function deleteClinicTimeSlot(e, clinicId, slotId, timeSlotId) {
    const slots = clinicTimeSlots?.filter((item) => {
      return item?.timeSlotId !== timeSlotId;
    });

    setClinicTimeSlots(slots);
  }

  const handleSubmitAfter = () => {
    setSubmitForm(false);
    history.push("/");
  };

  const handlePrev = () => {
    setConsultation(false);
    setQualification(true);
  };

  useEffect(() => {
    if (Object.keys(profileData)?.length > 0) {
      let doctorClinics = profileData?.doctor_clinics;
      const clinicTimings = doctorClinics?.[0]?.clinic_timings || [];

      doctorClinics = doctorClinics?.filter((clinic) => {
        return clinic?.clinic_id != 0;
      });

      // If there are no timings, set Monday as the default selected day
      if (clinicTimings?.length === 0) {
        const defaultDay = "monday";
        const defaultSlot = {
          clinicId: 1,
          slotsId: 1,
          timeSlotId: 1,
          day: defaultDay,
        };

        setClinicTimeSlots([defaultSlot]);

        // ✅ Set 'monday' as string, not array (for radio button)
        form.setFieldsValue({
          [`visit-day1`]: defaultDay,
        });

        // Initialize videoSlots for UI to show at least one slot
        setClinicSlots([
          {
            clinicId: 1,
            slotsId: 1,
          },
        ]);
      }
    }
  }, [JSON.stringify(profileData)]);

  useEffect(() => {
    if (Object.keys(profileData)?.length > 0) {
      const doctorClinics = profileData?.doctor_clinics;
      const clinicTimings = doctorClinics?.[0]?.clinic_timings || [];

      // If there are no timings, set Monday as the default selected day
      if (clinicTimings?.length === 0) {
        const defaultDay = "monday";
        const defaultSlot = {
          clinicId: 1,
          slotsId: 1,
          timeSlotId: 1,
          day: defaultDay,
        };

        setVideoTimeSlots([defaultSlot]);

        // ✅ Set 'monday' as string, not array (for radio button)
        form.setFieldsValue({
          [`video_day1`]: defaultDay,
        });

        // Initialize videoSlots for UI to show at least one slot
        setVideoSlots([
          {
            clinicId: 1,
            slotsId: 1,
          },
        ]);
      }
    }
  }, [JSON.stringify(profileData)]);

  const handleTermsModalShow = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      const errors = form.getFieldsError();

      // Check for any fields with errors
      const erroredField = errors.find((field) => field.errors.length > 0);
      if (erroredField) {
        toast.error(`${erroredField.name[0]}: ${erroredField.errors[0]}`);
        return;
      }

      // Check if any field value is empty/null/undefined
      for (const [key, value] of Object.entries(values)) {
        if (value === undefined || value === null || value === "") {
          toast.error(`${key} is required`);
          return;
        }
      }

      // All good, show modal
      setTermsModalShow(true);
    } catch (err) {
      console.error("Validation failed:", err);
    }
  };

  return (
    <>
      {submissionLoader && <Loader />}
      <div className="steps_form">
        <div style={{ marginTop: 16, borderTop: "0.5px solid #8E96A0" }}>
          <Form form={form} onFinish={handleNext} className="mt-4">
            <VideoConsultation
              profileData={profileData}
              videoClinics={videoClinics}
              setVideoClinics={setVideoClinics}
              videoSlots={videoSlots}
              setVideoSlots={setVideoSlots}
              videoTimeSlots={videoTimeSlots}
              setVideoTimeSlots={setVideoTimeSlots}
              clinicVisit={clinicVisit}
              setClinicVisit={setClinicVisit}
              clinicSlots={clinicSlots}
              setClinicSlots={setClinicSlots}
              clinicTimeSlots={clinicTimeSlots}
              setClinicTimeSlots={setClinicTimeSlots}
              videoConsultCheckbox={videoConsultCheckbox}
              videoClinicCheckbox={videoClinicCheckbox}
              setVideoClinicCheckbox={setVideoClinicCheckbox}
              setVideoConsultCheckbox={setVideoConsultCheckbox}
              form={form}
            />

            <div className="buttons_box">
              <div className="box_buttons">
                {/* <Button style={{ marginRight: 8 }} className="btn btn-01 bg-light1" onClick={(e) => handleNext(e, true)} >
                                        Save
                                    </Button> */}
                <Button
                  type="primary"
                  className="btn btn-01 bg-dark1 ssx"
                  onClick={() => handleTermsModalShow()}
                >
                  Submit
                </Button>
                {/* <Row>
                  <Col lg={6} md={6} className="text-start">
                    {!isMobile ? (
                      <>
                        <Button className="btn  btn-01 bg-light1" onClick={handlePrev}>
                                                        Back to Qualifications
                                                    </Button>
                      </>
                    ) : null}
                  </Col>
                  {isMobile && !videoConsultCheckbox && !videoClinicCheckbox ? (
                    <>
                      <Col lg={6} md={6} className="text-end hk_bottom_stick">
                        <Button
                          disabled
                          style={{
                            marginRight: 8,
                            opacity: 1,
                            backgroundColor: "#EFEFEF",
                            color: "#8E8E8E",
                            display: "block",
                            textAlign: "center",
                            margin: "auto",
                            border: "none",
                          }}
                          className="btn btn-01 bg-light1"
                        >
                          Next
                        </Button>
                      </Col>
                    </>
                  ) : (
                    <Col
                      lg={6}
                      md={6}
                      className={isMobile ? "text-center" : "text-end"}
                    ></Col>
                  )}
                </Row> */}
              </div>
            </div>
          </Form>
        </div>
      </div>

      <Modal
        title=""
        centered
        visible={confirmFormSubmit}
        onOk={() => setConfirmFormSubmit(false)}
        onCancel={() => setConfirmFormSubmit(false)}
        className="confirmFormSubmit"
      >
        <div className="confirmModal">
          <div className="text-center">
            <img src={imageFormModal} className="img-fluid"></img>
            <h6>Your profile will be verified within 3 working days</h6>
            <hr></hr>
          </div>
          <div className="list_modal">
            <p>
              Please make sure that you have added the following fields
              correctly:
            </p>
            <ul className="listing">
              <li>PMDC Number</li>
              <li>Email Address / Number</li>
              <li>Profile image</li>
            </ul>
            <div className="text-center">
              <Button className="btn btn-modal" onClick={handleSubmitForm}>
                SUBMIT
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        title=""
        centered
        visible={submitForm}
        onOk={() => setSubmitForm(false)}
        onCancel={() => setSubmitForm(false)}
        className="confirmFormSubmit hideclosebtn"
      >
        <div className="confirmModal">
          <div className="text-center pd-5">
            <img src={imageFormModal} className="img-fluid"></img>
            <h6>Your profile has been submitted successfully!</h6>
          </div>
          <div className="list_modal text-center">
            <p className="m-0 pb-4 text-black">
              Our team will verify your information to ensure authenticity.
              <br></br> Thank you for your patience during this process.{" "}
            </p>

            {isMobile ? (
              <div className="text-center">
                <Button className="btn btn-modal" onClick={handleSubmitAfter}>
                  OK
                </Button>
              </div>
            ) : (
              <div className="text-center">
                <Button className="btn btn-modal" onClick={handleSubmitAfter}>
                  OKAY
                </Button>
              </div>
            )}
          </div>
        </div>
      </Modal>
      {/* <div className="toast_blue width_toast">
        <ToastContainer />
      </div> */}

      <TermsModal
        visible={termsModalShow}
        onCancel={() => setTermsModalShow(false)}
        onAccept={async () => {
          setTermsModalShow(false);
          // validate fields first
          try {
            await form.validateFields();
            handleNext(null, false);
          } catch {
            // if validation fails, re-open modal so they can fix
            setTermsModalShow(true);
          }
        }}
      />
    </>
  );
};

export default StepThree;
